/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Page Footer
 */

// Style
import './style.scss';

const PageFooter = (props) => {
    const {footer} = props;

    return (
        <footer id="footer">
            <div className="container text-center">
                <div className="copyright">
                    {footer.copyright} | {footer.links}
                </div>
                <div className="credits">
                    {footer.credits}
                </div>
            </div>
        </footer>
    );
}

export default PageFooter;